<template>
    <div class="modal" tabindex="-1">
        <div class="modal-dialog">
            <div class="modal-content">
               <div class="modal-header p-2" style="height:64px">
                <h5 class="modal-title">{{$t('Crop')}} {{getThumbnailType}} {{$t('thumbnail')}}</h5>
                <div class="dialog-actions-wrapper">
                    <div class="dropdown">
                        <button id="manualDrawDropdown" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" class="btn button-styles manual-draw-box btn-outline-secondary dropdown-toggle" :title="$t('Crop options')">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-crop" viewBox="0 0 16 16">
                                    <path d="M3.5.5A.5.5 0 0 1 4 1v13h13a.5.5 0 0 1 0 1h-2v2a.5.5 0 0 1-1 0v-2H3.5a.5.5 0 0 1-.5-.5V4H1a.5.5 0 0 1 0-1h2V1a.5.5 0 0 1 .5-.5m2.5 3a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-1 0V4H6.5a.5.5 0 0 1-.5-.5"/>
                            </svg>
                        </button>
                        <div class="dropdown-menu" aria-labelledby="manualDrawDropdown">
                            <div class="crop-aspect-ratio-options">
                                    <ul>
                                        <li @click.stop="handleAspectRatioClick(aspectR)" class="aspect-ratios" :class="isActiveItem == aspectR.Aspectratio ? 'active':''" v-for="aspectR in cropAspectRatios" :key="aspectR.Aspectratio">
                                            <div class="aspect-ration-icons">
                                                <div class="crop-icon">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-crop" viewBox="0 0 16 16">
                                                       <path d="M3.5.5A.5.5 0 0 1 4 1v13h13a.5.5 0 0 1 0 1h-2v2a.5.5 0 0 1-1 0v-2H3.5a.5.5 0 0 1-.5-.5V4H1a.5.5 0 0 1 0-1h2V1a.5.5 0 0 1 .5-.5m2.5 3a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-1 0V4H6.5a.5.5 0 0 1-.5-.5"/>
                                                    </svg>
                                                </div>
                                                <div class="crop-name">
                                                    {{aspectR.Aspectratio}}
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                             </div>
                        </div>
                    </div>

                     <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close" :title="$t('Close')" @click="closeDialog()">  
                        <span aria-hidden="true">
                            <CancelIcon class="close-icon" style="height: 40px !important;width: 40px !important;color: #fff;" />
                        </span>
                    </button>
                </div>
               </div>
               <div class="modal-body">
                <div id="crop-with-aspect-ratio-wrapper">
                    <img  @load="initializeCroper" id="crop_with_aspect_ratio"  :src="getProxyConvertedURL(imageUrl)" style="display:block;max-width: 100%;height:100%;"/>
                 </div>
               </div>
               <div class="modal-footer p-0 primary-btn-style">
                    <button class="btn btn-outline-secondary ml-1" :title="$t('Cancel Cropping')" @click="$emit('closeCropDialog')">{{$t('Cancel')}}</button>
                    <button class="btn btn-outline-primary ml-1" :title="$t('Apply Crop')" @click="applyCrop()">{{$t('Apply')}}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import 'cropperjs/dist/cropper.css';
import Cropper from 'cropperjs';
import CancelIcon from "./InlineCancelField.vue";
export default {
  props:["imageUrl","thumbnailType","captureFrameTimeMMS"],
  components:{CancelIcon},
  data(){
     return {
         cropper:null,
         cropAspectRatios:[{ratio:4 / 3, Aspectratio: '4:3'},{ratio: 3 / 4, Aspectratio: '3:4'},{ratio: 16 / 9, Aspectratio: '16:9'},{ratio: 9 / 16, Aspectratio: '9:16'},{ratio: 20 / 9, Aspectratio: '20:9'},{ratio: 9 / 20, Aspectratio: '9:20'}],
         isActiveItem:null,
     }
  },
  methods:{
      initializeCroper(){
            const image = document.getElementById('crop_with_aspect_ratio');
            this.cropper = new Cropper(image, {
                    background:true,
                    movable:false,
                    autoCrop:true,
                    covered: true,
                    center:true,
                    viewMode: 1 ,
                    zoomable: false,
                    scalable: false,
                    ready: () =>{  
                       this.cropper.clear();
                       this.cropper.disable();
                    }
            });
            console.log("cropper",this.cropper,Cropper);
      },
      handleAspectRatioClick(aspectR){
          console.log("[handleAspectRatioClick]",aspectR);
          this.cropper.enable();
          this.cropper.setAspectRatio(aspectR.ratio);
          this.isActiveItem = aspectR.Aspectratio;
          this.cropper.crop();
      },

      applyCrop(){
         const croppedCanvas = this.cropper.getCroppedCanvas();
        // Convert canvas to base64 PNG
        const croppedImageBase64 = croppedCanvas.toDataURL("image/png");
        let data = {};
        data['image'] = croppedImageBase64;
        if(this.captureFrameTimeMMS){
          data['frameTime'] = this.captureFrameTimeMMS;
        }
        this.$emit("croppedBase64Data",data);
      },

      closeDialog(){
         if(this.isActiveItem){
            if(confirm(this.$t("You have unsaved crop changes. Are you sure you want to discard them?"))){
                this.$emit('closeCropDialog');
            }
         }else{
            this.$emit('closeCropDialog');
         }
      },
  },
  computed:{
     getThumbnailType(){
        if(this.thumbnailType == 'primaryThumbnail'){
           return this.$t("primary")
        }
        return this.$t("secondary")
     }
  },
}
</script>

<style scoped lang="scss">
$primary-background: #1a1e21;
$border-color: 1px solid #4a4a4a;
$primary-background: #1a1e21;
$secondary-background-color:#15181B;
$text-color: #eee;
$dull-text-color: #757575;
$secondary-text-color: #9c9c9c;
$active-blue : #007bff;
$secondary-border-color: 1px solid #2b2b2b;
$icon-hover:#2c3339;

  #crop-with-aspect-ratio-wrapper{
     width: 100vw;
     height: calc(100vh - 67px);
     position: relative;
  }

  #crop_with_aspect_ratio{
    width: 100%;
    height: 100%;
  }

  .crop-aspect-ratio-options{
    list-style: none;
    width: 100%;
    background: rgba(0, 0, 0, 0.35);
    height: 64px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-inline-start: 6px;
    padding-inline-end: 6px;

     ul{
        list-style: none;
        display: flex;
        gap: 20px;
        margin: 0;
        padding: 0;
        justify-content: center;
     }

     ul li{
        padding: 1px 12px;
        border-radius: 4px;
        color: $text-color;
     }

    .aspect-ratios.active{
        background: #fff;
        transition: all .3s ease;

        .aspect-ration-icons{
            color: #4b4b4b;
        }
     }
  }

  .aspect-ration-icons{
      display: flex;
      flex-direction: column;
      align-items: center;
      .crop-icon {
          svg {
            width: 30px;
            height: 30px;
          }
      }
      .crop-name{
         font-size: 12px;
      }
  }

  .dialog-actions-wrapper{
    display: flex;
  }

  .close-icon-wrapper{
    position: relative;
    bottom: 1px;
    .close-icon{
        height: 30px !important;
        width: 30px !important;
        color: $dull-text-color !important;
    }
}

.close-icon:hover{
  background: $icon-hover;
  border-radius: 20px;
}


#manualDrawDropdown svg{
      fill: rgb(201, 201, 201); 
      height: 23px; 
      color: rgb(203, 203, 203);
}


.modal-dialog {
    width: 100vw;
    height: 100vh;
    max-width:100%;
    margin: 0;
    padding: 0;
  }

 .modal-content {
    height: auto;
    min-height: 100%;
    border: 0 none;
    border-radius: 0;
    box-shadow: none;
    background: $primary-background !important;
    border: $secondary-border-color;
    .modal-body{
      background: $primary-background;
      overflow:auto;
    //   height:300px;
        height: calc(100% - 65px);
      padding: 0px 0px 0px 0px;
    //   display:inline-flex;
      width:100%;
      position:relative;
    }
  }

.modal {
  text-align: center;
  padding: 0!important;
  display:block;
}
.modal:before {
  content: '';
  display: inline-block;
  height: 100%;
  vertical-align: middle;
  margin-inline-end: -4px;
}
.modal-dialog {
  display: inline-block;
  text-align: start;
  vertical-align: middle;
}

.modal-header,.modal-footer{
    border-top: $secondary-border-color !important;
    border-bottom: $secondary-border-color !important;
    // background: $secondary-background-color;
    background: #1a1e21 !important;
    align-items: unset;
    .modal-title{
      color:$text-color;
      padding:3px;
    }
}

.modal-header .close {
    // margin: -1rem -19px -0rem auto !important;
    margin:0px !important;
    padding: 0px !important;
}

.modal-footer{
    inset-inline-start: 0;
    bottom: 0;
    width: 100%;
    z-index: auto;
    align-items: center;
    position: fixed;
    padding: 2px 5px !important;
    background: linear-gradient(to right, rgba(0, 0, 0, 0.2), rgb(1 1 1)) !important;
    pointer-events: none;

    button{
      pointer-events: all;
    }
}

.header{
    max-height: 64px;
}

  ::v-deep{
    .cropper-bg{
       background-image: none !important;
    }

    .dropdown-menu{
        background-color: #212122 !important;
    }

    .dropdown-menu.show{
         padding: 0 !important;
         background-color: #212122 !important;
    }
    .cropper-modal{
       opacity: 0.8 !important;
    }

    .cropper-point {
      width: 8px !important;
      height: 8px !important;
    }
  }
</style>